package com.nonopn.skydome.common.app.api

enum class Mode {
    Normal,
    Admin
}
